module.exports = __webpack_public_path__ + "img/cloud-fill.869d0066.svg";